<div
  style="
    background-image: url('../../../../assets/imagesNew/Proceed2.png') !important;
    background-size: cover;
    height: 100vh;
  "
>
  <p-dialog
    [(visible)]="displaypopup"
    [draggable]="false"
    [modal]="true"
    positionType="absolute"
    [closable]="false"
    [maximizable]="false"
    [style]="{ width: '20vw' }"
  >
    <p-header>
      <!--{{popupheader}}-->
      <h2
        class="mb-0"
        style="font-weight: unset !important; font-size: larger !important"
      >
        Emergency Token
      </h2>
    </p-header>

    <div class="grid">
      <div class="col-12 p-md12">
        <form [formGroup]="emergencyToken" (ngSubmit)="resetToken()">
          <div class="p-fluid formgrid grid">
            <div class="field col-12 md:col-12">
              <span class="field p-float-label">
                <input
                  id="float-input1"
                  type="password"
                  appFormErrorMessages
                  pInputText
                  formControlName="emergencyToken"
                  autocomplete="new-password"
                />
                <label for="float-input1">
                  <span class="required-asteric"> * </span>Enter Emergency
                  Token</label
                >
              </span>
            </div>

            <div
              class="field col-12 md:col-12 buttonWidth-8 mb-0"
              style="margin-left: 6rem; text-align: center !important"
            >
              <button
                pButton
                type="submit"
                icon=""
                label="Validate"
                class="p-button-plain"
                [disabled]="emergencyToken.invalid"
              ></button>
            </div>
          </div>
        </form>

        <div
          class="col-12 p-messagesp-messages-summary border-radius-5"
          *ngIf="ShowErrorSummary"
        >
          <span style="font-size: 14px">{{ errorValidationSummary }}</span>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
